export enum TextType {
    SearchBox = 'searchbox',
}
